export const colore = {
  actions: { // TODO: questo deve sparire perché non ha il minimo senso
    okay: 'rgb(153, 226, 17)',
    help: 'rgb(251, 158, 36)',
    error: 'rgb(255, 0, 0)',
    action: 'rgb(245, 194, 35)',
    escape: 'rgb(251, 91, 111)',
    hint: 'rgb(179, 166, 255)',
  },
  ui: {
    contrast: 'rgb(255, 255, 255)', // $bg-contrast
    softBg: 'rgb(251, 251, 251)', // $main-bg-color
    mainBg: 'rgb(240, 240, 240)', // $neutral-bg
    neutralBg: 'rgb(231, 236, 236)', // $empty-element
    darkBg: 'rgb(209, 209, 209)', // $dark-bg
    lightBg: 'rgb(216, 216, 216)', // $progress-bar-bg
    txt: 'rgb(78, 78, 78)', // $main-text-color
    darkTxt: 'rgb(51, 51, 51)', // $darker-text-color:
    lightTxt: 'rgb(164, 164, 164)', // $lighter-text-color
    groupLabelTxt: 'rgb(96, 96, 96)', // $grey-label-text
    okTxt: 'rgb(126, 211, 33)', // $ok-text-color
    note: '#FFFDDE', // $note-bg
    noteBorder: '#D5D3C1', // $note-border
    contesto: 'rgb(255, 100, 0)', // $contest-text-color
    feedback: 'rgb(26, 185, 26)', // $feedback-color
    notification: '#f4443e',
  },
  landing: {
    green: '#9bdd3e',
    orange: '#fe9d3e',
    grey: '#F2F2F2',
    dark: 'rgba(0, 133, 178, 1)',
    formazione: '#446069',
  },
};
